export default __webpack_public_path__ + "static/media/white_bg_1_1.a3f0e6ad.webp";